import React, { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import {
  AlertBox,
  DynamicTag,
  PageActionPlaceHolder,
  Spinner
} from 'msp-components'
import { IMachine, useAccount } from 'msp-integrations'
import AccountMachineRegister from './AccountMachineRegister/AccountMachineRegister'
import AccountMachineDisplay from './AccountMachineDisplay/AccountMachineDisplay'
import translations from './AccountMachines.constants'
import * as S from './AccountMachines.styles'

export type AccountMachinesNoMachinesProps = {
  elemRef: React.MutableRefObject<AlertBox>
}

const AccountMachinesNoMachines = ({
  elemRef
}: AccountMachinesNoMachinesProps) => {
  const { formatMessage } = useIntl()

  return (
    <PageActionPlaceHolder
      heading={formatMessage(translations.placeholderHeading)}
      text={formatMessage(translations.placeholderText)}
      buttonText={formatMessage(translations.placeholderCTAText)}
      onButtonClick={() => elemRef?.current?.showAlert()}
    />
  )
}

const AccountMachines = () => {
  const newMachineDialogRef = useRef<AlertBox>()
  const { formatMessage } = useIntl()
  const {
    machines: {
      isLoading,
      isProcessingAction,
      hasMachines,
      machines,
      getMachines,
      getRegisterableMachines
    }
  } = useAccount()

  useEffect(() => {
    getMachines()
    getRegisterableMachines()
  }, [])

  return (
    <div className={S.MainWrapper}>
      <DynamicTag
        componentTagName='Headline'
        tag='h2'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.myMachines)}
      </DynamicTag>
      {(isLoading || isProcessingAction) && <Spinner fullScreen />}
      {!isLoading && !hasMachines && (
        <AccountMachinesNoMachines elemRef={newMachineDialogRef} />
      )}
      {!isLoading &&
        hasMachines &&
        machines.map((machine: IMachine) => (
          <AccountMachineDisplay
            key={`machine-${machine.SerialNo}`}
            machine={machine}
          />
        ))}
      <AccountMachineRegister
        hideButton={!hasMachines}
        elemRef={newMachineDialogRef}
      />
    </div>
  )
}

export default AccountMachines
